// Fulfilment options describe the various ways that a user can receive a product
const HomeDelivery = 'HomeDelivery';
const NationalDelivery = 'NationalDelivery';
const Collection = 'Collection';
const Domestic = 'Domestic';
const RestOfWorld = 'RestOfWorld';
const NoFulfilmentOptions = 'NoFulfilmentOptions';
export { HomeDelivery, NationalDelivery, Collection, Domestic, RestOfWorld, NoFulfilmentOptions, };
